import { render, staticRenderFns } from "./pan.vue?vue&type=template&id=a00ed546"
import script from "./pan.vue?vue&type=script&lang=js"
export * from "./pan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports